import { ClientOrgBoard } from '../components/clientOrganization'

const ClientOrganizationView = () => <ClientOrgBoard />

export { ClientOrganizationView }
